/**
 * @author        calvin@zumper.com (Calvin Yau)
 * @copyright     Copyright (c) 2019, Zumper
 * @description   ManageTitle constants
 */

export const DEFAULT_TITLE = 'Apartments for Rent - Zumper'
